import { z } from "zod"

export const TENANTS = ["siro", "fieldpro"] as const

export type Tenant = (typeof TENANTS)[number]

export const DEFAULT_TENANT: Tenant = "siro"

export const tenantSchema = z.enum(TENANTS)

export const isTenant = (value: unknown): value is Tenant =>
  tenantSchema.safeParse(value).success
